import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const ApplicationContainer = styled.div`
	padding: 4rem 8rem;
`;
export const ApplicationTitle = styled(Typography)`
	color: #545351;
	font-size: 1.2rem;
	margin-bottom: 1rem;
`;

export const ApplicationHeader = styled.div`
	width: 100%;
	margin-bottom: 1rem;
`;

export const NameText = styled.span`
	width: 55%;
	display: inline-block;
`;

export const ApiText = styled.span`
	width: 20%;
	display: inline-block;
`;

export const ContentContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const ContentBody = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	cursor: pointer;
	&:hover {
		background-color: #e3e3e3 !important;
	}
`;

export const AppNameContainer = styled.div`
	width: 55%;
	display: flex;
	align-items: center;
`;

export const ApiContainer = styled.div`
	width: 20%;
	display: flex;
	align-items: center;
`;

export const ImageContainer = styled.div`
	margin: 1rem 1rem 1rem 0;
	width: 3.5rem;
	height: 3.5rem;
	padding: 0.6rem;
	border-radius: 12px;
	background-color: #c4c4c4;
	display: inline-block;
`;

export const DescriptionContainer = styled.div`
	color: #545351;
	display: inline-block;
`;
